<template>
    <svg
        width="65"
        height="29"
        viewBox="0 0 65 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M7.89591 7.73144V11.3709H15.585V18.9811H7.89591V27.997H0V0.0800781H16.7838L17.3213 7.73144H7.89591Z"
            fill="#003998"
        />
        <path
            d="M39.8634 4.37154C42.4829 7.0466 43.7933 10.2758 43.7933 14.0585C43.7933 17.8685 42.4827 21.1109 39.8634 23.7864C37.2435 26.4613 34.0836 27.7988 30.3837 27.7988C26.6565 27.7988 23.4826 26.4613 20.8632 23.7864C18.2432 21.1111 16.9335 17.8685 16.9335 14.0585C16.9335 10.2757 18.2432 7.0466 20.8632 4.37154C23.4826 1.69647 26.6565 0.358887 30.3837 0.358887C34.0835 0.358887 37.2435 1.69647 39.8634 4.37154ZM28.1149 19.6518C28.1149 20.2738 28.3441 20.814 28.8036 21.2731C29.2625 21.7329 29.8165 21.9623 30.4646 21.9623C31.1129 21.9623 31.6597 21.7329 32.1054 21.2731C32.5512 20.814 32.7739 20.2738 32.7739 19.6518V8.34358C32.7739 7.69515 32.5512 7.14157 32.1054 6.68183C31.6599 6.22278 31.113 5.99279 30.4646 5.99279C29.8165 5.99279 29.2626 6.22278 28.8036 6.68183C28.344 7.14157 28.1149 7.69515 28.1149 8.34358V19.6518Z"
            fill="#003998"
        />
        <path
            d="M56.1117 28.0801L52.1433 21.0075L48.2988 28.0801H39.6175L47.8855 13.6044L40.0722 0.0800781H49.0016L52.2675 6.11844L55.5745 0.0800781H64.2143L56.5665 13.5216L64.9998 28.08H56.1117V28.0801Z"
            fill="#003998"
        />
    </svg>
</template>

<script>
export default {
    name: 'Fox'
};
</script>
